import React, { useState, useEffect } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useLocation } from "react-router-dom";
import "react-tabs/style/react-tabs.css";
import { backendApi } from "../../api/apiService";
import CandidateInfo from "./candidateInfo.jsx";
import MakeOffer from "./makeOffer.jsx";
import OfferLetterDetails from "./offerLetterDetails.jsx";
import CandidateHistory from "./history.jsx";
import ViewResumes from "./viewResumes.jsx";
import OfficeDetails from "./officeDetails.jsx";
import SkillRange from "./skillCompenent.jsx";
import { FaPlusCircle, FaEdit, FaCheckCircle, FaTrash } from "react-icons/fa";
import Select from "react-select";
import noDataSvg from "../../images/noData.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdOutlinePersonOutline } from "react-icons/md";
import { FaLocationDot, FaInfo } from "react-icons/fa6";
import { GrInProgress } from "react-icons/gr";
import { FaHandshake } from "react-icons/fa";
import { IoMdCloseCircle } from "react-icons/io";
import { useSelector } from "../../components/hooks/hooks";
import ReactStars from "react-rating-stars-component";
import NewInterviews from "./candidateProfileComponents/newInterviews.jsx";
import { useNavigate } from "react-router-dom";
import { BsArrowLeftCircleFill } from "react-icons/bs";

function CandidateProfile() {
  const [tabIndex, setTabIndex] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const candidateId = location.pathname.split("/")[2];
  const [candidate, setCandidate] = useState(null);
  const [attachments, setAttachments] = useState(null);
  const [candidateSkill, setCandidateSkill] = useState([]);
  const [recCandidateSkill, setRecCandidateSkill] = useState([]);
  const [skillValues, setSkillValues] = useState();
  const [jobSkills, setJobSkills] = useState([]);
  const [jobRecSkills, setJobRecSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedTechSkills, setSelectedTechSkills] = useState([]);
  const [recSelectedSkills, setRecSelectedSkills] = useState([]);
  const [recSkillId, setRecSkillId] = useState([]);
  const [interviewData, setInterviewData] = useState([]);
  const [status, setStatus] = useState("");
  const [suggestion, setSuggestion] = useState("");
  const [interviewId, setInterviewId] = useState(null);
  const [editStatus, setEditStatus] = useState(false);
  const [NewRow, setNewRow] = useState(false);
  const [NewRowTechnical, setNewRowTechnical] = useState(false);
  const [showSkills, setShowSkills] = useState(false);
  const [showRemarks, setShowRemarks] = useState(false);
  const [interviewSkills, setInterviewSkills] = useState([]);
  const [openingSkills, setOpeningSkills] = useState([]);
  const [menuClick, setMenuClick] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [fieldDisableOrNot, setFieldDisableOrNot] = useState("");
  const [remarks, setRemarks] = useState("");
  const [newRemarks, setNewRemarks] = useState("");
  const [newRemarksTech, setNewRemarksTech] = useState("");
  const [rating, setRating] = useState("");
  const [ratingTech, setRatingTech] = useState("");
  const { userDetails } = useSelector((state) => state.login);
  const { awsData, recuitmentStatus } = useSelector(
    (state) => state.commonData
  );

  useEffect(() => {
    setFieldDisableOrNot(userDetails[0]?.role_id === 4 ? true : false);
    candidateInit();
  }, []);

  const handleBack = (candidate) => {
    console.log('Location state:', location.state);
    if (location.state?.from === 'onboard') {
      navigate('/onBoard');
    } else if (location.state?.from === 'viewmatch') {
      navigate('/viewMatchingRecruiters');
    } else if (location.state?.from === 'searchResult') {
      navigate('/dashboard/searchResult');
    } else if (location.state?.from === 'schedulepage') {
      navigate('/schedule/schedules');
    }
    else if (location.state?.from === 'resumeMatch') {
      navigate(`/viewMatchingRecruiters`, {
        state: {
          props: location.state.props
        },
      });
    }
    else {

    }
  };
  const handleAddSelectedSkills = (technical) => {
    const updatedSkills = [...candidateSkill];
    const skillExists =
      technical === 0
        ? updatedSkills.some(
          (skill) => skill.skill_name === selectedSkills.label
        )
        : updatedSkills.some(
          (skill) => skill.skill_name === selectedTechSkills.label
        );
    if (!skillExists) {
      if (technical === 0) {
        updatedSkills.push({
          skill_name: selectedSkills.label,
          rating: rating,
          is_technical: technical,
          remarks: newRemarks,
        });
      } else {
        updatedSkills.push({
          skill_name: selectedTechSkills.label,
          rating: ratingTech,
          is_technical: technical,
          remarks: newRemarksTech,
        });
      }
    }
    const skill_name = updatedSkills
      .filter((f) => f.is_technical === technical)
      .map((skillData) => skillData.skill_name);
    const ratings = updatedSkills
      .filter((f) => f.is_technical === technical)
      .map((skillData) => String(skillData.rating || 0));
    const remarks = updatedSkills
      .filter((f) => f.is_technical === technical)
      .map((skillData) => String(skillData.remarks || "NA"));
    var req = {
      functionName: "saveInterviewSkills",
      interview_id: interviewId,
      candidate_id: candidateId,
      skill_name,
      ratings,
      remarks,
      isTechnical: technical,
      created_by: localStorage.getItem("userId"),
    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        toast.success("Review submitted successfully", { containerId: "Z" });
        setCandidateSkill(updatedSkills);
        setSelectedSkills("");
        setSelectedTechSkills("");
        setRatingTech(0);
        setRating(0);
        setNewRemarks("");
        setNewRemarksTech("");
        // candidateInit();
      } else {
        console.error("Error", response);
        return false;
      }
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Hired":
        return "green";
      case "Rejected":
        return "red";
      case "ShortListed":
        return "blue";
      case "Applied":
        return "gold";
      case "Screened":
        return "purple";
      case "Interviewed":
        return "orange";
      case "Offer":
        return "#45cbcb";
      default:
        return "red";
    }
  };

  const insertNewSkill = (event) => {
    if (event.key == "Enter" && event.target.value.trim() !== "") {
      const newSkillLabel = event.target.value.trim();
      const skillExists = jobSkills.some(
        (skill) => skill.label.toLowerCase() === newSkillLabel.toLowerCase()
      );
      let newSkillValue = jobSkills.length;
      if (!skillExists) {
        const newSkill = {
          label: newSkillLabel,
          value: newSkillValue,
        };
        setJobSkills([...jobSkills, newSkill]);
      }
      event.target.value = "";
    }
  };

  const handleInterviewSelection = (event) => {
    let selectedInterview = interviewData.find((x) => x.id == event);
    setInterviewId(event);
    const skillsForSelectedInterview = interviewSkills.filter(
      (skill) => skill.interview_id == event
    );

    if (skillsForSelectedInterview.length > 0) {
      setCandidateSkill(skillsForSelectedInterview);
    } else {
      // setCandidateSkill(openingSkills);
      setCandidateSkill([]);
    }
    setSelectedSkills("");
    setSelectedTechSkills("");
    setNewRemarks("");
    setNewRemarksTech("");
    setRating(0);
    setRatingTech(0);
    setRemarks(selectedInterview.Remarks);
    setShowSkills(true);
    setShowRemarks(true);
  };

  const Cancel = () => {
    setEditStatus(false);
    setShowPopup(false);
  };

  const handleStatusEdit = (event) => {
    setSelectedStatus(event.target.value);
  };

  const saveCandidateStatus = () => {
    if (selectedStatus === "") {
      toast.warn("Please select a status", { containerId: "Z" });
      return false;
    }
    var req = {
      functionName: "CandidateStatusChange",
      site_id: localStorage.getItem("siteId"),
      candidate_id: candidateId,
      status: selectedStatus,
    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        toast.success("Status Updated Succesfully", { containerId: "Z" });
        setShowPopup();
        candidateInit();
      } else {
        console.error("Error");
        return false;
      }
    });
  };

  const candidateInit = () => {
    var req = {
      functionName: "candidateProfile",
      site_id: localStorage.getItem("siteId"),
      candidate_id: candidateId,
    };
    backendApi(req).then((response) => {
      console.log("🚀 ~ backendApi ~ response:", response);
      if (response.success === "1") {
        const initialSkillValues = {};
        response.candidate_skills.forEach((skillData) => {
          initialSkillValues[skillData.skill_name] = skillData.skillValue;
        });

        setOpeningSkills(response.job_opening_skill);
        const transformedOptions = response.candidate_skills.map(
          (skill, index) => ({
            value: skill.id,
            label: skill.skill_name,
          })
        );

        const filteredSkills = response.savedInterviewSkills.filter(
          (skill) =>
            skill.interview_id === null || skill.interview_id === undefined
        );
        setRecCandidateSkill(filteredSkills);
        setJobSkills(transformedOptions);
        setSkillValues(initialSkillValues);
        setCandidate(response.dataSet);
        setSelectedStatus(response.dataSet[0].status);
        setAttachments(response.attachments);
        setInterviewData(response.interviewDetails);
        setInterviewSkills(response.savedInterviewSkills);
        // if (interviewId !== "" && showSkills === true) {
        //   handleInterviewSelection(interviewId);
        // }
      } else {
        console.error("Error while fetching candidate data");
        return false;
      }
    });
  };

  const handleSkillSelect = (selectedOption, technical) => {
    if (Boolean(technical)) {
      setSelectedTechSkills(selectedOption);
    } else {
      setSelectedSkills(selectedOption);
    }
    console.log("🚀 ~ handleSkillSelect ~ selectedOption:", selectedOption);
  };
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };
  const cancelNewRow = () => {
    setNewRow(false);
  };
  const deleteSkill = (skill_id) => {
    const api = {
      functionName: "deleteInterviewSkills",
      skill_id,
    };
    backendApi(api).then((response) => {
      candidateInit();
    });
    console.log("🚀 ~ deleteSkill ~ api:", api);
  };
  const editRating = (rating, skill_id) => {
    const api = {
      functionName: "editInterviewDetails",
      rating,
      skill_id,
    };
    backendApi(api).then((response) => {
      candidateInit();
    });
  };
  const goToEvaluationPage = (candidateId) => {
    console.log(candidateId, "candidateId");

    navigate(`/candidate/candidateEvaluation`, {
      state: {
        candidateId,
        from: 'candidateProfile'
      },
    });
  };
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header
            Header="Candidate Profile"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          />
          <div className="main-container">
            <ToastContainer
              enableMultiContainer
              containerId={"Z"}
              position="bottom-right"
              autoClose={1500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
            <div className="xilliWrap">
              <div className="card main-card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12 xilliBrudcrb">
                      <div className="candidateProfile">
                        {/* <div className="d-md-flex justify-content-end">
                        
                          {candidate &&
                            candidate.length > 0 &&
                            candidate[0].status ? (
                            <span
                              className="job_search_status_profile"
                              style={{
                                border:
                                  "1px solid " + getStatusColor(selectedStatus),
                              }}
                            >
                              {selectedStatus}{" "}
                              <span className="ml-1">
                                <FaCheckCircle
                                  fill={getStatusColor(selectedStatus)}
                                ></FaCheckCircle>
                              </span>
                            </span>
                          ) : (
                            <span
                              className="job_search_status_profile"
                              style={{ border: "1px solid #F44336" }}
                              color="#F44336"
                            >
                              Not Available{" "}
                              <span className="ml-1">
                                <IoMdCloseCircle
                                  fill={"#F44336"}
                                ></IoMdCloseCircle>
                              </span>
                            </span>
                          )}
                          {!fieldDisableOrNot && (
                            <span className="d-flex align-items-center">
                              <FaEdit
                                className="edit ms-2"
                                title="Change Status"
                                onClick={() => setShowPopup(true)}
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          )}
                        </div> */}
                      </div>

                      <div className="profile-wrapper xilliRight">
                        {/* <div className="profile-wrapper xilliRight"> */}
                        <div className="tabs-common">
                          <Tabs
                            selectedIndex={tabIndex}
                            onSelect={(index) => setTabIndex(index)}
                          >
                            <TabList>
                              <Tab>Candidate</Tab>
                              <Tab>Office Details</Tab>
                              <Tab>Interviews</Tab>
                              {!fieldDisableOrNot && <Tab>Recruiters</Tab>}
                              <Tab>Attachments</Tab>
                              {!fieldDisableOrNot && <Tab>Make Offer</Tab>}
                              {!fieldDisableOrNot && (
                                <Tab> Offer Letter Details</Tab>
                              )}
                              <Tab> History</Tab>
                            </TabList>
                            <TabPanel>
                              {candidate && (
                                <CandidateInfo
                                  fieldDisableOrNot={fieldDisableOrNot}
                                  candidateInit={candidateInit}
                                  candidate={candidate[0]}
                                />
                              )}
                            </TabPanel>
                            <TabPanel>
                              {candidate && (
                                <OfficeDetails
                                  fieldDisableOrNot={fieldDisableOrNot}
                                  candidateInit={candidateInit}
                                  candidate={candidate[0]}
                                />
                              )}
                            </TabPanel>

                            <TabPanel>
                              <div className="cardDeatils">
                                {/* <div className="sub-head">
                                  Interview Details
                                </div> */}
                                {interviewData.length > 0 ? (
                                  <button
                                    className="btn-btn btn btn-btn2"
                                    onClick={() =>
                                      goToEvaluationPage(candidateId)
                                    }
                                  >
                                    Evaluation
                                  </button>
                                ) : ""}
                                <div className="table-responsive">
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th
                                          style={{
                                            width: "25%",
                                            minWidth: "200px",
                                          }}
                                        >
                                          Interview Details
                                        </th>
                                        <th
                                          style={{
                                            width: "25%",
                                            minWidth: "200px",
                                          }}
                                        >
                                          Description
                                        </th>
                                        <th
                                          className="text-center"
                                          style={{
                                            width: "25%",
                                            minWidth: "200px",
                                          }}
                                        >
                                          Duration
                                        </th>
                                        <th
                                          style={{
                                            width: "10%",
                                            minWidth: "100px",
                                          }}
                                        >
                                          Status
                                        </th>
                                        {!fieldDisableOrNot ? (
                                          <th
                                            className="text-center"
                                            style={{
                                              width: "10%",
                                              minWidth: "70px",
                                            }}
                                          >
                                            Actions
                                          </th>
                                        ) : (
                                          ""
                                        )}
                                      </tr>
                                    </thead>
                                    {interviewData.length > 0 ? (
                                      interviewData.map((data, index) => (
                                        <tbody
                                          className={
                                            interviewId == data.id
                                              ? "highlight-row"
                                              : ""
                                          }
                                        >
                                          <tr key={data.id}>
                                            <td>
                                              {data.Interviewer_name.split(
                                                ","
                                              ).map((interviewer, index) => (
                                                <span
                                                  className="shortlist-name"
                                                  key={index}
                                                >
                                                  {interviewer.trim()}
                                                  {index !==
                                                    data.Interviewer_name.split(
                                                      ","
                                                    ).length -
                                                    1
                                                    ? " "
                                                    : ""}
                                                </span>
                                              ))}
                                              <div class="mb-2">
                                                <span class="label-text me-1">
                                                  {" "}
                                                  <FaHandshake
                                                    title="interviewType"
                                                    size={12}
                                                  />
                                                </span>
                                                <span class="font-Medium ">
                                                  {data.interview_type}
                                                </span>
                                              </div>
                                              <div class="mb-2">
                                                <span class="label-text me-1">
                                                  {" "}
                                                  <FaLocationDot
                                                    title="location"
                                                    size={12}
                                                  />
                                                </span>
                                                <span class="font-Medium ">
                                                  {data.location}
                                                </span>
                                              </div>
                                            </td>
                                            <td>
                                              {" "}
                                              <span class="font-Medium job-desc">
                                                {data.description}
                                              </span>
                                            </td>
                                            <td>
                                              <div class="mb-2">
                                                <span class="label-text me-1 d-block text-center">
                                                  {" "}
                                                  {data.start_date}
                                                </span>
                                                <span class="font-Medium  d-block text-center">
                                                  to
                                                </span>
                                                <span class="label-text me-1  d-block text-center">
                                                  {" "}
                                                  {data.end_date}
                                                </span>
                                              </div>
                                            </td>
                                            <td>
                                              <div class="mb-2">
                                                <span class="label-text me-1">
                                                  {" "}
                                                  <GrInProgress
                                                    title="status"
                                                    size={12}
                                                  />
                                                </span>
                                                <span class="font-Medium">
                                                  {data.status
                                                    ? data.status
                                                    : "Not available"}
                                                </span>
                                              </div>
                                              <div class="mb-2">
                                                <span class="label-text me-1">
                                                  {" "}
                                                  <FaInfo
                                                    title="suggestions"
                                                    size={12}
                                                  />
                                                </span>
                                                <span class="font-Medium">
                                                  {data.suggestion
                                                    ? data.suggestion
                                                    : "Not available"}
                                                </span>
                                              </div>
                                            </td>
                                            {!fieldDisableOrNot ? (
                                              <td className="text-center">
                                                <FaEdit
                                                  onClick={() => {
                                                    setInterviewId(data.id);
                                                    setEditStatus(true);
                                                  }}
                                                />
                                              </td>
                                            ) : (
                                              ""
                                            )}
                                          </tr>
                                        </tbody>
                                      ))
                                    ) : (
                                      <tbody>
                                        <tr>
                                          <td
                                            colSpan={7}
                                            className="text-center py-5"
                                          >
                                            <img
                                              src={noDataSvg}
                                              width={50}
                                              height={50}
                                              className="img-fluid mb-4"
                                              alt="no data found"
                                            ></img>
                                            <p
                                              className="text-danger"
                                              style={{ fontSize: "16px" }}
                                            >
                                              No Interviews Scheduled
                                            </p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    )}
                                  </table>
                                </div>
                              </div>
                            </TabPanel>

                            <TabPanel>
                              {candidate && (
                                <ViewResumes
                                  attachments={attachments}
                                  candidate={candidate[0]}
                                />
                              )}
                            </TabPanel>
                            {candidate && !fieldDisableOrNot && (
                              <TabPanel>
                                {candidate && (
                                  <MakeOffer
                                    candidateInit={candidateInit}
                                    candidate={candidate[0]}
                                  />
                                )}
                              </TabPanel>
                            )}
                            {candidate && !fieldDisableOrNot && (
                              <TabPanel>
                                {candidate && (
                                  <OfferLetterDetails
                                    // candidateInit={candidateInit}
                                    candidate={candidate[0]}
                                  />
                                )}
                              </TabPanel>
                            )}
                            <TabPanel>
                              <CandidateHistory />
                            </TabPanel>
                          </Tabs>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {showPopup && (
              <div
                className="modal_parent"
                id="deletesprint"
              // hidden={removeSprint}
              >
                <div className="module_popup deletePeople">
                  <div className="module_innerpopup module_bodypop">
                    <div className="module_headdiv">
                      <h4 className="popup_head"> Change Status</h4>
                    </div>
                    <div className="form-row">
                      <label htmlFor="" className="form-label">
                        Status<span className="red ml-1">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="status"
                        value={selectedStatus}
                        onChange={handleStatusEdit}
                      >
                        <option value="">-Select-</option>
                        {recuitmentStatus?.length > 0 &&
                          recuitmentStatus?.map((data) => {
                            return (
                              <>
                                <option value={data}>{data}</option>
                              </>
                            );
                          })}
                      </select>
                    </div>
                    <div className="mt-2 d-flex aling-items-center flex-wrap gap-3 justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-btn1 btn-btn"
                        onClick={saveCandidateStatus}
                      >
                        Save
                      </button>
                      <button
                        type="button"
                        className="btn btn-btn2 btn-btn"
                        onClick={() => Cancel()}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <button
            type="button"
            className="floating-back-button"
            onClick={() => handleBack(candidate)}
          >
            <BsArrowLeftCircleFill size={24} />
          </button>
        </div>
      </div>
    </>
  );
}

export default CandidateProfile;
